<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps({
  error: Object as () => NuxtError,
})

function handleError() {
  clearError()
  navigateTo('/')
}
</script>

<template>
  <div class="min-h-screen bg-primary-dark text-zinc-50 relative overflow-clip flex items-center justify-center">
    <img
      src="/icon.svg"
      class="absolute -bottom-64 -left-64 z-3 w-1/3 h-auto"
    >
    <img
      src="/icon.svg"
      class="absolute top-32 rotate-90 right-0 lg:-right-24 z-3 w-1/2 lg:w-1/8 h-auto"
    >
    <div class="mx-auto max-w-screen-2xl w-full px-6">
      <div class="flex flex-col max-w-6xl mx-auto relative z-20">
        <h1 class="font-title text-4xl lg:text-7xl pb-4">
          Whoops!
        </h1>
        <p
          v-if="error?.statusCode === 404"
          class="text-lg md:text-xl lg:text-2xl"
        >
          Page not found! If you are having trouble finding what you are looking for, please contact us.
        </p>
        <p
          v-else
          class="text-lg md:text-xl lg:text-2xl"
        >
          We're sorry, but something went wrong. We've been notified about this issue and we'll take a look at it
          shortly.
        </p>
        <ButtonBasic
          size="xl"
          class="self-start mt-6"
          @click="handleError"
        >
          Go Home
        </ButtonBasic>
      </div>
    </div>
  </div>
</template>
